/**
 * @template T extends Record<string, string>
 * @param {string|string[]} root The “namespace” base (either a string or an array of strings).
 * @param {T} attribs An object whose property-values are themselves strings that need namespacing.
 * @returns {{ [K in keyof T]: string }}
 *   A new object with exactly the same keys as `attribs`, but where each
 *   value is the namespaced string (always a `string`).
 */
export function namespaced(root, attribs = {}) {
  // helper that takes a “leaf” string and prefixes it with `root`
  const ns = (r) => {
    const base = Array.isArray(r) ? r : [r];
    return (leaf) => [...base, leaf].join('/');
  };

  const _ns = ns(root);

  return Object.keys(attribs).reduce((acc, key) => {
    // cast to `any` temporarily so JS doesn’t error at runtime;
    // the JSDoc above guarantees IDEs know “attribs[key] is string”
    const leaf = /** @type {any} */ (attribs[key]);
    return {
      ...acc,
      [key]: _ns(leaf),
    };
  }, /** @type {{ [K in keyof T]: string }} */ ({}));
}


export const mapSetter = (state, setters = {}) => (
  Object.keys(state).reduce((accumulator, stateName) => {
    const get = state[stateName]
    const set = setters[stateName]

    accumulator[stateName] = { get, set }

    // check if setter exists
    if (!set) {
      delete accumulator[stateName].set
    }

    return accumulator
  }, {})
)
